export const dateSegmentTheme = {
   light: {
      placeholderColor: 'text-gray-500',
      cell: {
         background: 'bg-primary-300',
         color: 'text-gray-900',
         disabledColor: 'text-gray-500',
         focusColor: 'focus:bg-gray-200'
      }
   },
   dark: {}
}
